var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-wrapper',{attrs:{"isLoading":_vm.gridLoading}},[_c('grid-gcr',{attrs:{"data":_vm.projects,"columns":_vm.columns},on:{"update":_vm.updateProjectsList},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}})],1),_c('paging-gcr',{attrs:{"callback":_vm.changePage,"pageCount":_vm.pageCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }